var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.business,"item-text":"name","item-value":"value","hide-no-data":""},model:{value:(_vm.companySelected),callback:function ($$v) {_vm.companySelected=$$v},expression:"companySelected"}})}
var staticRenderFns = []

export { render, staticRenderFns }